import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'fe-appdir-lib-theme';

const PROP_TYPES = {
  layout: PropTypes.oneOf(['center', 'left', 'right', 'justify']),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  bgImage: PropTypes.string,
  featureImage: PropTypes.string,
  featureImageAlt: PropTypes.string,
  minHeight: PropTypes.string,
};

const DEFAULT_PROPS = {
  layout: 'center',
  minHeight: '240px',
};

const Container = styled.div`
  background-image: ${(props) =>
    props.bgImage
      ? `url(${props.bgImage}),
        linear-gradient(to right, #2cd5c4, #00c3d5, #00aeef)`
      : `linear-gradient(to right, #2cd5c4, #00c3d5, #00aeef)`};
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: right top;
  display: flex;
  justify-content: center;
  padding: ${theme.spacingMd} 15px;
  min-height: ${(props) => props.minHeight};
`;

const WidthWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap-reverse;
  justify-content: center;
  max-width: 940px;
`;

const TextWrapper = styled.div`
  text-align: ${(props) => props.layout};
  width: ${(props) => (props.featureImage ? '60%' : '100%')};
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial;
  text-shadow: 0 0 2px ${theme.colorBase};
  color: ${theme.colorWhite};
  padding: ${theme.spacingMd} 0;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1000px) {
    /* @TODO get from theme */
    text-align: center;
    width: 100%;
  }
`;

const H2 = styled.h2`
  margin: 0;
  font-size: 42px;
  font-weight: 700;
`;

const H3 = styled.h3`
  font-size: 16px;
`;

const ImageWrapper = styled.div`
  display: ${(props) => (props.featureImage ? 'flex' : 'none')};
  padding: 16px; /* @TODO get from theme */
  flex-direction: row;
  justify-content: center;
`;

const Image = styled.img`
  @media (max-width: 1000px) {
    /* @TODO get from theme */
    width: 50%;
    height: 100%;
  }
`;

const TitleBar = ({
  bgImage,
  layout,
  featureImage,
  title,
  subtitle,
  featureImageAlt,
  minHeight,
}) => (
  <Container bgImage={bgImage} minHeight={minHeight}>
    <WidthWrapper>
      <TextWrapper layout={layout} featureImage={featureImage}>
        <H2>{title}</H2>
        <H3>{subtitle}</H3>
      </TextWrapper>
      <ImageWrapper featureImage={featureImage}>
        <Image src={featureImage} alt={featureImageAlt} />
      </ImageWrapper>
    </WidthWrapper>
  </Container>
);

TitleBar.propTypes = PROP_TYPES;
TitleBar.defaultProps = DEFAULT_PROPS;
TitleBar.displayName = 'TitleBar';

export default TitleBar;
